/** @format */

import { ISchema } from '@formily/react'
import { Input } from './Input'
export const Password: ISchema = {
  type: 'object',
  properties: {
    ...(Input.properties as Record<string, unknown>),
    checkStrength: {
      type: 'boolean',
      'x-decorator': 'FormItem',
      'x-component': 'Switch'
    }
  }
}
